import React from 'react';
import { Gallery, Section, SectionSubTitle } from 'common/components';
import { INTERIOR_DOORS_ELEMENT_BLOCK } from '../../interior-doors-constants';
import { INTERIOR_DOORS_GALLERY } from './interior-doors-gallery-constants';
import { interiorDoorsGallery, interiorDoorsGalleryImage } from './interior-doors-gallery-styles';

type RoomDoorsGalleryProps = {
  onConsultationSignupBtnClick: () => void;
};

export const InteriorDoorsGallery: React.FC<RoomDoorsGalleryProps> = ({ onConsultationSignupBtnClick }) => (
  <Section>
    <SectionSubTitle margin="m">Наши двери в&nbsp;разных интерьерах</SectionSubTitle>
    <Gallery
      elementBlock={INTERIOR_DOORS_ELEMENT_BLOCK}
      elementText="Решение для любого случая"
      galleryImageClassName={interiorDoorsGalleryImage}
      galleryGridClassName={interiorDoorsGallery}
      imageList={INTERIOR_DOORS_GALLERY}
      imagePerPage={INTERIOR_DOORS_GALLERY.length}
      modalBtnProps={{
        onClick: onConsultationSignupBtnClick,
      }}
    />
  </Section>
);
